<template>
    <div>
        <h1>Khách hàng</h1>

      <b-tabs content-class="mt-3">
        <b-tab title="Thông tin khách hàng" active>
            <h1 class="row">
                <b-button variant="primary" @click="mode='edit'" class="ml-2" v-if="mode=='view'">Sửa</b-button>
                <b-button variant="primary" @click="mode='view'" class="ml-2" v-if="mode=='edit'">Thoát</b-button>

                <b-button variant="primary" @click="copyC4()" class="ml-2">Copy C4</b-button>
            </h1>

            <div >
              <b-input ref="c4_input"  :value="c4_data"></b-input>
            </div>
            
            <generic-detail-view
                    rootPath="/v2/clients"
                    :forms="forms"
                    :columns="columns"
                    :table_name="table_name"
                    :service="clientService"
                    layout="grid"
                    v-if="mode=='view'"
                    >

            </generic-detail-view>

             <generic-form-view
                rootPath="/v2/clients"
                :forms="forms"
                :columns="columns"
                :table_name="table_name"
                @onSubmitted="mode='view'"
                v-if="mode=='edit'"
                >

            </generic-form-view>
        </b-tab>
        <b-tab title="Mô tả nhu cầu">
          <needs-list v-bind:clientId="$route.params.id">
          </needs-list>

          <hr/>
          <h1>
                <b-button variant="primary" @click="mode='edit'" class="ml-2" v-if="mode=='view'">Sửa</b-button>
                <b-button variant="primary" @click="mode='view'" class="ml-2" v-if="mode=='edit'">Thoát</b-button>
            </h1>

          <generic-detail-view
                    rootPath="/v2/clients"
                    :forms="clientNeedsMeta.input_view.forms"
                    :columns="clientNeedsMeta.columns"
                    :table_name="clientNeedsMeta.table_name"
                    :service="clientService"
                    layout="grid"
                    v-if="mode=='view'"
                    >

            </generic-detail-view>

            <generic-form-view
                rootPath="/v2/clients"
                :forms="clientNeedsMeta.input_view.forms"
                :columns="clientNeedsMeta.columns"
                :table_name="clientNeedsMeta.table_name"
                @onSubmitted="mode='view'"
                v-if="mode=='edit'"
                >

            </generic-form-view>
        </b-tab>
        <b-tab title="Trao đổi">
            <!-- <h1>Lịch sử trao đổi</h1> -->

            <client-chat-logs v-bind:clientId="clientId">

            </client-chat-logs>
        </b-tab>

         <b-tab title="Đề xuất sản phẩm">
            <!-- <h1>Lịch sử trao đổi</h1> -->
            <p v-if="!isAdmin">Đang phát triển</p>
            <product-suggestion v-bind:clientId="clientId" v-if="isAdmin">

            </product-suggestion>
        </b-tab>
      </b-tabs>

    </div>

</template>

<script>
import GenericDetailView from '@/views/base/GenericDetailView'
import GenericFormView from '@/views/base/GenericFormView'
import ProductSuggestion from '@/module-product-suggestion/ProductSuggestion'

import ClientInfoMeta from './ClientTableMeta'
import ClientNeedsMeta from './ClientNeedsMeta'
import NeedsList from '@/module-needs/NeedsList'
import ClientService from './ClientService'

import ClientChatLogs from '@/module-chat/ClientChatLogs'

export default {
  name: 'ClientViewDetail',
  components: {
      'generic-detail-view': GenericDetailView,
      'generic-form-view': GenericFormView,
      'client-chat-logs': ClientChatLogs,
      'product-suggestion': ProductSuggestion,
      'needs-list': NeedsList,
    },
  data () {
    return {
        forms: ClientInfoMeta.input_view.forms,
        columns: ClientInfoMeta.columns,
        table_name: ClientInfoMeta.main_table_name,

        clientNeedsMeta: ClientNeedsMeta,

        clientService: new ClientService(ClientInfoMeta.main_table_name),
        clientId: null,
        messages: [],

        mode: 'view',
        c4_data: '',
        show_c4_field: false,

        clientInfo: {
            fullname: '',
            phone: ''
        }
    }
  },
  computed: {
    isAdmin() {
      if (this.$store.getters.role == 'admin') {
        return true;
      }
      return false;
    }
  },
  watch: {

  },
  methods: {
    gotoEdit () {
      var id = this.$route.params.id;
      this.$router.push({path: `/v2/clients/${id}`});
    },

    async loadC4() {
      var clientInfo = await this.clientService.getDetail(this.clientId);

      var text = clientInfo.fullname + '-' + window.location.href;
      this.c4_data = text;

      console.log(text);
    },

    copyC4() {
      
      try {
        this.$refs.c4_input.select();
        document.execCommand("copy");

        navigator.clipboard.writeText(this.c4_data); // desktop
        // Alert the copied text
        alert("Thông tin đã được copy: " + this.c4_data);
      }
      catch(err) {
        console.log(err);
      }
    }
  },
  async mounted () {
    this.clientId = this.$route.params.id;
    
    this.mode = this.$route.query.mode ? this.$route.query.mode : 'view';

    this.loadC4();

    // var recordInfo = await this.clientService.getDetail(this.clientId);
    // this.clientInfo.fullname = recordInfo.fullname;
    // this.clientInfo.phone = recordInfo.phone;


    //   this.clientService = new ClientService(TableMeta.table_name);
    

  }
}
</script>

<style scoped>
.text-bold {
    font-weight: bold;
}
</style>

